<template>
  <div id="listagem-solicitacao">
    <div class="func-historico" v-if="listaInterna.length || listaExterna.length">
        <div class="filters">
          <filtros
            :classe="'btn-filter'"
            :name="'Filtros'"
            :ativos="filtrosAtivos"
            v-on:clickButton="showDialog = true"
          />
          <el-button
            v-if="Object.keys(outputJson).length > 0"
            type="text"
            @click="limparFiltros"
          >
            Limpar
          </el-button>
          <filterDialog
            :componentList="inputJson"
            :open.sync="showDialog"
            :title="title"
            :output.sync="outputJson"
          />
        </div>
        <div
          v-for="(card, index) of solicitacoesFiltradas"
          :key="index"
          style="margin-top: 5px; cursor:pointer;"
        >
          <div
            v-if="card.cardExterno"
          >
            <slot
              name="externo"
              :card="card"
            />
          </div>

          <div
            v-else
          >
            <slot
              name="interno"
              :card="card"
            />
          </div>
        </div>
    </div>
    <ErrorVazio
      style="margin-top: 100px;"
      v-if="!listaExterna.length && !listaInterna.length"
      :show-btn="false"
    />
  </div>
</template>
<script>
import Filtros from '@/components/buttons/Filtros.vue'
import StatusItem from '@/components/listagemColumn/StatusItem.vue'
import DataItem from '@/components/listagemColumn/DataItem.vue'
import FilterDialog from '@/components/filterDialog/FilterDialog'
import { mapGetters } from 'vuex'
import OcorrenciaItem from '@/components/listagemColumn/OcorrenciaItem'
import { mapSectionListByContrato } from '@/components/TemplateSolicitacao/TemplateSolicitacaoHelpers'
import ErrorVazio from '@/components/Error/ErrorVazio'

export default {
  name: 'ComponenteSolicitacaoHistorico',
  components: {
    ErrorVazio,
    Filtros,
    FilterDialog
  },
  data () {
    return {
      filtros: [
        {
          active: true,
          name: 'Agrupar contatos'
        },
        {
          active: false,
          name: 'periodo'
        },
        {
          active: false,
          name: 'Localização'
        },
        {
          active: false,
          name: 'Ordenar'
        }
      ],
      columns: [
        {
          field: 'id_tipo_ocorrencia',
          component: OcorrenciaItem
        },
        {
          field: 'status_label_interna',
          component: StatusItem,
          title: 'Situação'
        },
        {
          field: 'data_registro',
          component: DataItem,
          title: 'Data solicitação'
        }
      ],
      title: 'Filtros',
      // language=JSON
      inputText: `[
        {
          "title": "Ordenar por",
          "field": "ordenacao",
          "type": "radio",
          "elements": [
            {
              "name": "Assunto",
              "field": "assunto",
              "order": "ASC",
              "id": 2
            },
            {
              "name": "Mais novos Primeiro",
              "field": "data_registro",
              "order": "DESC",
              "id": 3
            },
            {
              "name": "Mais antigos Primeiro",
              "field": "data_registro",
              "order": "ASC",
              "id": 4
            }
          ]
        },
        {
          "title": "Período",
          "type": "periodo",
          "field": "periodo",
          "hasOthers": true,
          "elements": [
            {
              "name": "180 Dias",
              "periodo": 180,
              "id": 1
            },
            {
              "name": "90 Dias",
              "periodo": 90,
              "id": 2
            },
            {
              "name": "30 Dias",
              "periodo": 30,
              "id": 3
            }
          ]
        },
        {
          "title": "Assunto",
          "field": "assunto",
          "elements": []
        },
        {
          "title": "Situação",
          "field": "situacao",
          "elements": []
        },
        {
          "title": "Contratos",
          "field": "contratos",
          "type": "agrupado",
          "elements": []
        }
      ]
      `,
      outputJson: {},
      showDialog: false
    }
  },
  props: {
    funcionalidade: {
      type: Object,
      default: () => ({})
    },
    listaExterna: {
      type: Array,
      default: () => []
    },
    listaInterna: {
      type: Array,
      default: () => []
    },
    chaveExterna: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('Login', ['user', 'contratos', 'beneficiarios']),
    filtrosAtivos () {
      return Object.values(this.outputJson).filter(this.isPreenchido).length
    },
    lista () {
      if (Array.isArray(this.listaExterna) && this.listaExterna.length > 0) {
        const mesclador = {}

        this.listaInterna.forEach((item) => {
          const numeroContrato = item.numeroContrato || 'n/a'
          mesclador[numeroContrato] = item
        })

        this.listaExterna.forEach((item) => {
          const numeroContrato = item.numeroContrato || 'n/a'
          const itemElement = item[this.chaveExterna]

          if (!mesclador[numeroContrato]) {
            mesclador[numeroContrato] = {
              numeroContrato: numeroContrato,
              ocorrencias: itemElement
            }
          } else {
            mesclador[numeroContrato].ocorrencias = mesclador[numeroContrato].ocorrencias.concat(itemElement)

            mesclador[numeroContrato].ocorrencias.sort((a, b) => {
              try {
                return Number.parseInt(b.data_registro) - Number.parseInt(a.data_registro)
              } catch (e) {
                return -1
              }
            })
          }
        })

        const listaMesclada = []

        Object.keys(mesclador).forEach((key) => {
          listaMesclada.push(mesclador[key])
        })

        return listaMesclada
      }

      return this.listaInterna
    },
    solicitacoesFiltradas () {
      let lista = [...this.contratosMapData]

      if (!this.outputJson || Object.keys(this.outputJson).length === 0) {
        return lista
      }

      const { situacao, assunto, contratos, periodo, ordenacao } = this.outputJson

      const situacaoFiltroDef = this.inputJson.find(f => f.field === 'situacao') || {}
      const elementosSituacao = situacaoFiltroDef.elements || []

      const assuntoFiltroDef = this.inputJson.find(f => f.field === 'assunto') || {}
      const elementosAssunto = assuntoFiltroDef.elements || []

      const filtroSituacoes = new Set(
        (situacao || []).map(id => {
          const elem = elementosSituacao.find(e => e.id === id)
          return elem ? elem.name : null
        }).filter(Boolean)
      )

      const filtroAssuntos = new Set(
        (assunto || []).map(id => {
          const elem = elementosAssunto.find(e => e.id === id)
          return elem ? elem.name : null
        }).filter(Boolean)
      )

      let inicio = null
      let fim = null

      if (periodo && periodo.customRange && periodo.customRange.length === 2) {
        inicio = new Date(periodo.customRange[0]).setHours(0, 0, 0, 0)
        fim = new Date(periodo.customRange[1]).setHours(23, 59, 59, 999)
      } else if (periodo && periodo.periodo) {
        const hoje = new Date()
        fim = hoje.setHours(23, 59, 59, 999)
        const dataLimite = new Date()
        dataLimite.setDate(hoje.getDate() - periodo.periodo)
        inicio = dataLimite.setHours(0, 0, 0, 0)
      }

      lista = lista.filter(item => {
        const passaSituacao = !filtroSituacoes.size || filtroSituacoes.has(item.status_label)
        const passaAssunto = !filtroAssuntos.size || filtroAssuntos.has(item.assunto)

        let passaContratoOuBeneficiario = true

        if (Array.isArray(contratos) && contratos.length > 0) {
          const selecionadosComChave = contratos.filter(c => c.chaveUnica)
          const selecionadosSemChave = contratos.filter(c => !c.chaveUnica)

          if (selecionadosComChave.length > 0) {
            const beneficiariosSelecionados = new Set(
              selecionadosComChave.map(c => c.id.split('-')[0])
            )
            const contratosSelecionados = new Set(
              selecionadosComChave.map(c => c.contrato)
            )
            passaContratoOuBeneficiario =
              beneficiariosSelecionados.has(item.identificador_beneficiario) &&
              contratosSelecionados.has(item.numero_contrato_solicitacao)
          } else if (selecionadosSemChave.length > 0) {
            const contratosSelecionados = new Set(
              selecionadosSemChave.map(c => c.contrato)
            )
            passaContratoOuBeneficiario = contratosSelecionados.has(item.numeroContrato)
          }
        }

        const passaPeriodo = (!inicio || !fim) || (item.data_registro >= inicio && item.data_registro <= fim)

        const resultado = passaSituacao && passaAssunto && passaContratoOuBeneficiario && passaPeriodo

        return resultado
      })

      if (ordenacao && ordenacao.field) {
        const campos = ordenacao.field.split('.')
        lista.sort((a, b) => {
          const getValue = obj => {
            let valor = obj
            for (let i = 0; i < campos.length; i++) {
              if (!valor) return null
              valor = valor[campos[i]]
            }
            return valor
          }

          const valorA = getValue(a)
          const valorB = getValue(b)

          if (ordenacao.order === 'ASC') {
            return valorA > valorB ? 1 : valorA < valorB ? -1 : 0
          } else {
            return valorA < valorB ? 1 : valorA > valorB ? -1 : 0
          }
        })
      }

      return lista
    },
    numeroContrato () {
      return this.$route.query.numeroContrato
    },
    contratosMapData () {
      let list = []
      if (this.contratosMap.length > 0) {
        this.contratosMap.forEach((value) => {
          list = list.concat(value.data)
        })

        return list
      }

      return []
    },
    contratosMap () {
      const contratosMap = mapSectionListByContrato(this.contratos, this.lista)

      if (this.numeroContrato) {
        return contratosMap.filter((v) => v.numeroContrato === this.numeroContrato)
      }

      return contratosMap
    },
    Json () {
      try {
        return JSON.parse(this.inputText)
      } catch (ignored) {
        return {}
      }
    },
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    inputJson () {
      this.preencheFiltros()
      try {
        return JSON.parse(this.inputText)
      } catch (ignored) {
        return {}
      }
    }
  },
  methods: {
    agruparContratos (beneficiarios) {
      const agrupado = {}
      for (const item of beneficiarios) {
        const plano = item.dadosDoPlano && item.dadosDoPlano.descricao
          ? item.dadosDoPlano.descricao
          : 'Sem Plano'

        const contrato = item.dadosDoContrato && item.dadosDoContrato.numeroContrato
          ? item.dadosDoContrato.numeroContrato
          : 'Sem Contrato'

        const contratoChave = plano + '||' + contrato

        const nome = item.dadosPessoais && item.dadosPessoais.nome
          ? item.dadosPessoais.nome
          : 'Sem Nome'

        const matricula = item.dadosDoPlano && item.dadosDoPlano.matricula
          ? item.dadosDoPlano.matricula
          : 'Sem Matrícula'

        const chaveUnica = item.chaveUnica

        const tipoUsuario = (
          item.dadosDoPlano &&
          item.dadosDoPlano.tipoUsuario &&
          item.dadosDoPlano.tipoUsuario.descricao
        ) ? item.dadosDoPlano.tipoUsuario.descricao : 'Desconhecido'

        if (!agrupado[contratoChave]) {
          agrupado[contratoChave] = {
            id: contrato,
            name: plano,
            beneficiarios: []
          }
        }

        agrupado[contratoChave].beneficiarios.push({
          nome: nome,
          matricula: matricula,
          tipoUsuario: tipoUsuario,
          chaveUnica: chaveUnica
        })
      }
      return Object.values(agrupado)
    },
    isPreenchido (v) {
      if (v === undefined || v === '' || v === null) return false
      if (Array.isArray(v) && v.length === 0) return false
      if (typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0) return false
      return true
    },
    limparFiltros () {
      this.outputJson = {}
    },
    preencheFiltros () {
      const chavesUnicas = new Set()
      const chavesAssuntos = new Set()
      let statusLista = []
      let assuntoLista = []

      for (const [i, item] of this.contratosMapData.entries()) {
        const chave = `${item.status_label}-${item.status_cor}`
        if (!chavesUnicas.has(chave)) {
          chavesUnicas.add(chave)
          statusLista.push({
            id: i,
            name: item.status_label,
            color: item.status_cor
          })
        }
        if (!chavesAssuntos.has(item.assunto) && item.assunto !== null) {
          chavesAssuntos.add(item.assunto)
          assuntoLista.push({
            id: i,
            name: item.assunto
          })
        }
      }
      let contratosLista = this.agruparContratos(this.beneficiarios)
      let json = []
      try {
        json = JSON.parse(this.inputText)
      } catch (e) {
        return {}
      }

      for (const filtro of json) {
        switch (filtro.field) {
          case 'situacao':
            filtro.elements = statusLista
            break
          case 'contratos':
            filtro.elements = contratosLista
            break
          case 'assunto':
            filtro.elements = assuntoLista
            break
          default:
            break
        }
      }
      this.inputText = JSON.stringify(json)
    }
  }
}
</script>
<style>
.func-historico {
  padding: 20px;

  .filters {
    margin-bottom: 30px;
    display: flex;
    flex-flow: row;
    align-items: center;
  }
}
</style>
